import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
import { BUY_LABEL } from '../../data/checkout';
export function FinalCta() {
  return <section aria-labelledby="cierre-title" className="w-full bg-coral-deep" data-id="element-211" data-mp="22d2ueba4ttte">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:px-8 lg:py-24" data-id="element-212" data-mp="1no6p2lzgmuwh">
        <svg viewBox="0 0 120 4" preserveAspectRatio="none" className="mx-auto h-1 w-16" aria-hidden data-id="element-213" data-mp="1snavj4v02ej4">
          <line x1="2" y1="2" x2="118" y2="2" stroke="#FFFFFF" strokeOpacity="0.7" strokeWidth="2" strokeLinecap="round" strokeDasharray="7 6" vectorEffect="non-scaling-stroke" data-id="element-214" data-mp="1eo1q908c14tx" />
        </svg>
        <h2 id="cierre-title" className="mt-5 font-serif text-[2.2rem] font-semibold leading-[1.08] text-white text-balance sm:text-[3rem]" data-id="element-215" data-mp="14qx430ehl9d4">
          Tu próxima prenda empieza con una idea.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[1.1rem] leading-relaxed text-white sm:text-[1.2rem]" data-id="element-216" data-mp="2z4o9fnps972r">
          Elegí entre 31 modelos y tené a mano los manuales y moldes para empezar.
        </p>
        <div className="mx-auto mt-9 flex w-full min-w-0 max-w-full justify-center" data-id="element-217" data-mp="27k2ocv08qsq">
          <CheckoutButton id="final-cta" label={BUY_LABEL} size="lg" tone="inverse" data-id="element-218" data-mp="3temrwyra8n0b" />
        </div>
      </div>
    </section>;
}